import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import styled from "styled-components";
import GradientButton from "../GradientButton";
import SuperCurrencyIcon from "../../assets/img/superverseLogo.png";
import QorbiIcon from "../../assets/img/GreenIsotype.png";
import SellWalletWarningModal from "./SellWalletWarningModal";
import { Context } from "../../context/WalletContext";
import LoaderModal from "./LoaderModal";

const fateIcon = 'https://img.cryptorank.io/coins/fate%20token1635248931540.png';

const StyledTransferAssetModal = styled.dialog`
    width: 600px;
    height: 450px;    
    border-radius: 35px;
    background-color: #1C1C1C;
    border-width: 0px;
    display: none;
    flex-direction: column;
    align-items: center;

    /* For Webkit-based browsers (Chrome, Safari, Edge) */
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* For Firefox */
    input[type="number"] {
        -moz-appearance: textfield;
    }

    &[open] {
        display: flex;
    }

    &::backdrop {
        background-color: #00000090;
    }

    .title {
        color: #FFFFFF;
        font-size: 22px;
        margin: 0px;
    }

    #image-asset {
        width: 150px;
        height: 150px;
        border-radius: 20px;
        background: #FFFFFF;
    }

    #asset-name {
        color: #FFFFFF;
        font-size: 26px;
        margin: 0px;
    }

    #asset-image-title {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 180px;
    }

    #quantity-container {
        width: 120px;
        height: 35px;
        background: #060E06;
        border-radius: 10px;
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    #submit-transfer {
        background: linear-gradient(#38EF7D, #11998E);
        height: 40px;
        width: 150px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
    }

    .quantity-controller {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        font-size: 22px;
    }

   #quantity-display {
        width: 120px;
        height: 35px;
        background: #060E06;
        border-radius: 10px;
        margin-top: 10px;
        color: #FFFFFF;
        font-size: 22px;
        display: block;
        margin : 0 auto;
        text-align: center;
        border-width: 0px;
        margin-bottom: 10px;
    }

    #animation-container {
        height: 64px;
        width: 65px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex: 2;
        width: 100%;
    }
  .listing-price {
        width: 150px;
        height: 40px;
        background: #2A2A2A;
        border: 1px solid #38EF7D;
        border-radius: 10px;
        margin: 10px 0;
        color: #FFFFFF;
        font-size: 16px;
        text-align: center;
    }

    #no-fees {
        color: #A9A9A9;
        font-size: 12px;
        text-align: center;
        margin-top: 10px;
    }
    .label {
        color: #FFFFFF;
        font-size: 14px;
        margin-bottom: 5px;
        align-self: start;
    }
    
    .listing-price-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10px;
    }
    .dropdown-container {
        position: relative;
        width: auto;
    }

    .dropdown-button {
        width: 150px;
        background-color: #2A2A2A;
        color: #FFFFFF;
        padding: 0.5rem 1rem;
        border-radius: 10px;
        border: 1px solid #38EF7D;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        transition: background-color 0.3s ease;
        font-size: 14px;
    }

    .dropdown-button:hover {
        background-color:#535353;
    }

    .dropdown-label {
        display: flex;
        align-items: center;
    }

    .dropdown-icon {
        width: 18px;
        height: 18px;
        margin-right: 0.5rem;
    }

    .dropdown-arrow {
        width: 16px;
        height: 16px;
        transition: transform 0.3s ease;
    }

    .rotate-180 {
        transform: rotate(180deg);
    }

    .dropdown-list {
        width: 150px;
        position: absolute;
        top: 71%;        
        background-color: #2A2A2A;
        color: #FFFFFF;
        border-radius: 10px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        border: 1px solid #38EF7D;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        padding: 0px;
        margin: 0px;
    }

    .dropdown-item {
        color: #FFFFFF;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: background-color 0.3s ease;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .dropdown-item:hover {
        background-color: #535353;
    }

    .dropdown-item-icon {
        width: 16px;
        height: 16px;
        margin-right: 0.5rem;
    }

    .content-container{
        display: flex;
        width: 100%;
        justify-content: space-evenly;
        align-items: center;  
        margin-top: 15px;      
    }

    @media(width <= 700px){
        height: 75vh !important;

        .content-container {
            flex-direction: column;
        }

        .dropdown-list {
            top: 81%; 
        }
    }
`;

const transferAssetModal = forwardRef(function TransferAssetModal({ imageUrl, assetName, onTransferSubmit, isLoading }, ref) {
    const priceInputRef = useRef();
    const modalRef = useRef();
    const sellModalRef = useRef();
    const loaderModalRef = useRef();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState("QORBI");
    const walletContext = useContext(Context);

    const currencies = [
        { label: "QORBI", icon: QorbiIcon },
        { label: "FATE", icon: fateIcon },
        { label: "SUPER", icon: SuperCurrencyIcon },
    ];

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const selectCurrency = (currency) => {
        setSelectedCurrency(currency);
        setIsDropdownOpen(false);
    };

    useImperativeHandle(ref, () => {
        return {
            open: open,
            close: close,
        };
    });

    function open() {
        modalRef.current.showModal();
    }

    function close() {
        modalRef.current.close();
    }

    function onSell() {
        sellModalRef.current.open();
        return;
    }

    async function sell() {
        const price = parseFloat(priceInputRef.current.value);
        if (isNaN(price) || price < 0.10) {
            return;
        }
        loaderModalRef.current.open();
        await onTransferSubmit(price, selectedCurrency);
        loaderModalRef.current.close();
    }

    useEffect(() => {
        if (!isLoading) {
            priceInputRef.current.value = parseFloat(10).toFixed(2);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <StyledTransferAssetModal ref={modalRef}>
            <SellWalletWarningModal
                ref={sellModalRef}
                onConfirm={sell}
                subtitle={"Are you sure you want to list this item for sale? This cannot be undone."}
                secondarySubtitle={"The payment for the transaction will go to your Qorbi Wallet, we strongly recommend you set a Metamask wallet as your Qorbi Wallet since Passport does not allow the use of external tokens."}
                warnedWalletKind={"Qorbi Wallet"}
                walletAddress={walletContext?.state?.userWallet?.qorbiWallet}
                confirmButtonText={"Sell"}
            ></SellWalletWarningModal>
            <LoaderModal ref={loaderModalRef} title={"Transferring Asset"} subtitle={"Wait a second..."}></LoaderModal>
            <p className="title">List Collectible</p>
            {
                <>
                    <div id="asset-image-title">
                        <img id="image-asset" alt={imageUrl} src={imageUrl}></img>
                        <p id="asset-name">{assetName}</p>
                    </div>
                    <div className="content-container">
                        <div className="listing-price-container">
                            <p className="label">Quantity</p>
                            <input type="number" className="listing-price" placeholder="1" disabled></input>
                        </div>
                        <div className="listing-price-container">
                            <p className="label">Listing Price (USD)</p>
                            <input ref={priceInputRef} type="number" className="listing-price" placeholder="0.00"></input>
                        </div>
                        <div className="listing-price-container">
                            <p className="label">Currency</p>
                            <button
                                className="dropdown-button listing-price"
                                onClick={toggleDropdown}
                            >
                                <span className="dropdown-label">
                                    <img
                                        className="dropdown-icon"
                                        src={currencies.find((c) => c.label === selectedCurrency)?.icon}
                                        alt={selectedCurrency}
                                    />
                                    {selectedCurrency}
                                </span>
                                <svg
                                    className={`dropdown-arrow ${isDropdownOpen ? "rotate-180" : "rotate-0"}`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </button>
                            {isDropdownOpen && (
                                <ul className="dropdown-list">
                                    {currencies.map((currency) => (
                                        <li
                                            key={currency.label}
                                            className="dropdown-item"
                                            onClick={() => selectCurrency(currency.label)}
                                        >
                                            <img className="dropdown-item-icon" src={currency.icon} alt={currency.label} />
                                            {currency.label}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                    {
                        selectedCurrency !== "QORBI" ?
                            <p id="no-fees">5% is taken from the sale.</p>
                            :
                            <p id="no-fees">No fees are taken from the sale.</p>
                    }
                    <div style={{ display: "flex", width: "100%", flexDirection: "row", justifyContent: "space-around" }}>
                        <GradientButton onTap={onSell} text={'Sell'}></GradientButton>
                        <GradientButton onTap={close} text={'Cancel'}></GradientButton>
                    </div>
                </>
            }
        </StyledTransferAssetModal>
    );
});

export default transferAssetModal;